// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__f5aqM","label":"Completed_label__2Xks5"};